import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_GIFT_CARD/REQUESTED';
const BLOCKED = '$FETCH_GIFT_CARD/BLOCKED';
const APPROVED = '$FETCH_GIFT_CARD/APPROVED';
const SUCCEEDED = '$FETCH_GIFT_CARD/SUCCEEDED';
const FAILED = '$FETCH_GIFT_CARD/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      giftCard: _GiftCard;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, request),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
